@if(checkListData && checkListData.length > 0) {
<div class="d-flex" style="display: flex; gap: 8px;">
  <!-- Collapsible menu for buttons -->
  <div class="d-flex justify-content-end" id="mobileMenu">
    @if(!isMobile){
    <div class="custom-row justify-content-start no-top-margin" style="gap: 8px;">
      <ppl-button label="Expand All" icon="fa fa-expand" [size]="'medium'" [customClass]="'ghost-button'"
        [iconPosition]="'right'" (click)="expandAll()"></ppl-button>
      <ppl-button label="Collapse All" icon="fa fa-compress" [size]="'medium'" [customClass]="'ghost-button'"
        [iconPosition]="'right'" (click)="hideAll()"></ppl-button>
      <ppl-button label="Download All" icon="fa fa-download" [size]="'medium'" [customClass]="'ghost-button'"
        [iconPosition]="'right'" (click)="downloadAll()"></ppl-button>
      <!-- Mail All button hidden -->
      <!-- <ng-container *ngIf="!readonly && !isNewReferral">
        <ppl-button label="Mail All" icon="fa fa-envelope" [size]="'medium'" [customClass]="'ghost-button'"
          [iconPosition]="'right'" (click)="showMailAllDialog()"></ppl-button>
      </ng-container> -->
    </div>
    }
  </div>
</div>
}
<div class="flex-col" style="gap: 8px;">
  @if(checkListData && checkListData.length > 0) {
  <div class="provider-enrollment-forms-section">
    <ppl-provider-enrollment-forms [providerId]="selectedProviderId" [selectedParticipantId]="selectedParticipantId"
      [programCode]="program.program_code" [readonly]="readonly" [participantPPLID]="pplId" [source]="source"
      (actions)="action($event, false)" [checklistGroups]="checkListData" [isAssociation]="false"
      [selectedProviderType]="selectedProviderType" [associationDetails]="providerAssociationDetails"></ppl-provider-enrollment-forms>
  </div>
  }
  @else if (isSelf){
  <nz-alert nzType="info" nzMessage="No Self forms available for you." nzShowIcon></nz-alert>
  }

  @if(prvdrAssociations && prvdrAssociations.length > 0) {
  <div class="ppl-mt16 flex-col" style="gap: 8px;">


    @if(isMobile) {
    <div class="checklist-header-item alert mobile-primary">
      <div>
        Associations
      </div>
    </div>

    <div class="card-layout">
      <div class="card" *ngFor="let association of prvdrAssociations">
        <div class="card-item">
          <strong>{{ association.participantFirstName }} {{ association.participantLastName }}</strong>
        </div>
        <div class="card-item d-flex justify-content-between">
          <div class="mt-3">
            {{association.providerTypeLabel}}
            <div>
              Start Date : {{association.associationStartDate}} @if(association.associationEndDate) { -
              {{association.associationEndDate}}}
            </div>
          </div>
          <div class="btn-group mb-3">
            <ppl-button ariaLabel="View" label="View" icon="fa fa-eye" [customClass]="'ghost-button'"
              [iconPosition]="'left'" (click)="action({data: association, action: 'view'}, false)"></ppl-button>
          </div>
        </div>
      </div>
    </div>

    } @else {
    <nz-collapse [nzExpandIconPosition]="'end'" [ngClass]="'pending pending-ant-collapse'">
      <nz-collapse-panel [nzActive]="true" [nzHeader]="'Associations'">
        <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true" [data]="prvdrAssociations"
          [disableSelection]="true" [cols]="cols" [gridTitle]="false" [pagination]="true" [loadPage]="false"
          (gridAction)="action($event, true)" [actionButtons]="participantAssociationActions">
        </ppl-list-table>
      </nz-collapse-panel></nz-collapse>
    }
  </div>

  }

  @if(isEmployerProvider && employerProviderList && employerProviderList.length > 0) {
  <div class="ppl-mt16 flex-col" style="gap: 8px;">
    <nz-collapse [nzExpandIconPosition]="'end'" [ngClass]="'pending pending-ant-collapse'">
      <nz-collapse-panel [nzActive]="true" [nzHeader]="'Providers'">
        <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true" [data]="employerProviderList"
          [disableSelection]="true" [cols]="employerProviderCols" [gridTitle]="false" [pagination]="true" [loadPage]="false"
          (gridAction)="employerProviderAction($event)" [actionButtons]="participantAssociationActions">
        </ppl-list-table>
      </nz-collapse-panel></nz-collapse>
  </div>
  }

  @if(isIndependentProvider && providerEmployerList && providerEmployerList.length > 0) {
  <div class="ppl-mt16 flex-col" style="gap: 8px;">
    <nz-collapse [nzExpandIconPosition]="'end'" [ngClass]="'pending pending-ant-collapse'">
      <nz-collapse-panel [nzActive]="true" [nzHeader]="'Employers'">
        <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true" [data]="providerEmployerList"
          [disableSelection]="true" [cols]="providerEmployerCols" [gridTitle]="false" [pagination]="true" [loadPage]="false"
          (gridAction)="providerEmployerAction($event)" [actionButtons]="participantAssociationActions">
        </ppl-list-table>
      </nz-collapse-panel></nz-collapse>
  </div>
  }
</div>


<div class="filter-panel">

  <ng-template #pdfDialog let-cancel="cancel">
    @if (!pdfReadonly) {
    <div class="action-panel">
      <div class="error-message fs-6" *ngIf="errors && errors.length > 0 && customError == ''">
        <i class="fa fa-exclamation-triangle" style="color: red;" aria-hidden="true"></i>
        {{ getErrorMessage(errors[0]) }}
      </div>

      <div class="error-message fs-6" *ngIf="customError">
        <i class="fa fa-exclamation-triangle" style="color: red;" aria-hidden="true"></i>
        {{ customError }}
      </div>

      <ppl-button label="Save Form" icon="fa fa-check-circle" [customClass]="'primary-button'" [disabled]="disableSave"
        [iconPosition]="'left'" (handleClick)="handleSave()" />
    </div>
    }
    <div class="" *ngIf="pdfConfig && pdfFile">
      <ppl-editpdf (fieldsUpdated)="fieldsUpdated($event)" [readonly]="pdfReadonly" [pdfConfig]="pdfConfig"
        #viewEditPDFComponent [signature]="signature" [pdfBlob]="pdfBlob" [pdfFile]="pdfFile"
        [signatureId]="signatureId" [isParticipantFlow]="isParticipantFlow"
        [selectedParticipantId]="selectedParticipantId" [isPdfSubmitted]="isPdfSubmitted"
        [selectedProviderType]="selectedProviderType" [isSelf]="isSelf" [resignRequired]="resignRequired"
        [ignorePartBValidationOfI9]="isI9Form && selectedProviderType !== 'EMP'" [SignOnly]="pdfSignOnly" [QRCodeData]="qrCode"></ppl-editpdf>
    </div>
  </ng-template>
  <ng-template #showChangesDialog let-cancel="cancel">
    @if (!readonly) {
    <div class="action-panel">
      <div class="error-message fs-6" *ngIf="errors && errors.length > 0 && customError == ''">
        <i class="fa fa-exclamation-triangle" style="color: red;" aria-hidden="true"></i>
        {{ getErrorMessage(errors[0]) }}
      </div>

      <div class="error-message fs-6" *ngIf="customError">
        <i class="fa fa-exclamation-triangle" style="color: red;" aria-hidden="true"></i>
        {{ customError }}
      </div>

      <ppl-button label="Save Form" icon="fa fa-check-circle" [customClass]="'primary-button'" [disabled]="disableSave"
        [iconPosition]="'left'" (handleClick)="handleSave()" />
    </div>
    }
    <div class="pdf-summary-wrapper" *ngIf="pdfConfig && pdfFile">
      <div class="pdf-panel">
        <ppl-editpdf (fieldsUpdated)="fieldsUpdated($event)" [readonly]="readonly" [pdfConfig]="pdfConfig"
          #viewEditPDFComponent [signature]="signature" [pdfBlob]="pdfBlob" [pdfFile]="pdfFile"
          [signatureId]="signatureId" [isParticipantFlow]="isParticipantFlow"
          [selectedParticipantId]="selectedParticipantId" [isPdfSubmitted]="isPdfSubmitted"
          [selectedProviderType]="selectedProviderType" [isSelf]="isSelf" [resignRequired]="resignRequired"
          [ignorePartBValidationOfI9]="isI9Form && selectedProviderType !== 'EMP'" [highlightedFields]="highlightedFields" [SignOnly]="true" [QRCodeData]="qrCode"></ppl-editpdf>
      </div>
      <div class="summary-panel">
        <h3 class="sub-header" tabindex="0">Summary of Changes</h3>
        <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="false" [data]="highlightedFields"
          [disableSelection]="true" [cols]="summaryCols" [gridTitle]="false"
          [pagination]="true"></ppl-list-table>
      </div>
    </div>
  </ng-template>
  <ng-template #associationsDialog>
    <!-- Provider Enrollment Forms (Dynamic Forms) -->
    @if(providerAssociationChecklist && providerAssociationChecklist.length > 0) {
    @if(selectedProviderId && program?.program_code && (selectedParticipantPplId || selectedLinkedMode)) {
    <div class="provider-enrollment-forms-section">
      <ppl-provider-enrollment-forms [providerId]="selectedProviderId" [selectedParticipantId]="selectedParticipantId"
        [programCode]="program.program_code" [readonly]="associationFormsReadonly" [participantPPLID]="selectedParticipantPplId" [source]="source"
        (actions)="action($event, true)" [checklistGroups]="providerAssociationChecklist" [isAssociation]="true" [relationToParticipant]="relationToParticipant"
        [selectedProviderType]="selectedProviderType" [formEntitiesOverride]="linkedFormEntities"
        [linkedSaveConfig]="linkedFormSaveConfig" [associationDetails]="providerAssociationDetails"></ppl-provider-enrollment-forms>
    </div>
    }
    } @else {
    <nz-alert nzType="info" nzMessage="No Association forms available for this provider." nzShowIcon></nz-alert>
    }
  </ng-template>
  <ng-template #formHistoryDialog>
    @if(formHistoryChecklist && formHistoryChecklist.length > 0) {
    @for(checkList of formHistoryChecklist; track $index) {
    <div class="mb-3">
      <h2 class="sub-header">{{ checkList.checklistName }}</h2>
      <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true" [data]="checkList.items"
        [disableSelection]="true" [cols]="historyCols" [gridTitle]="false" [pagination]="true" [loadPage]="false"
        [actionButtons]="actions" (gridAction)="action($event, isHistoryAssociation)">
      </ppl-list-table>
    </div>
    }
    } @else {
    <nz-alert nzType="info" nzMessage="There is no history available for this form." nzShowIcon></nz-alert>
    }
  </ng-template>
</div>

<ppl-popup-dialog [(isVisible)]="showConfirmationDialog" title="Confirm Mail All" isOkText="Mail All Forms"
  (cancel)="onCloseDialog()" [showButtons]="true" position="top" size="medium" (confirm)="handleConfirmMailAll()">
  <div>
    <h3 class="ppl-gray-text mb-4">
      Are you sure you wish to mail all forms?
    </h3>
    <p>
      This action cannot be undone.
    </p>
  </div>
</ppl-popup-dialog>

<ng-template #confirmationDialog2 let-confirm="confirm" let-cancel="cancel">
  <div>
    <h3 class="ppl-gray-text mb-4">
      Are you sure you wish to mail form?
    </h3>
    <p>
      This action cannot be undone.
    </p>
  </div>
</ng-template>